module.exports = __webpack_public_path__ + "img/whyChooseUs.a446c3e4.png";